// `enforce: 'pre'` : le worker doit être prêt avant les autres plugins
// (fetch-auth, keycloak) et le premier rendu, sinon les premières requêtes
// partent vers le vrai backend.
export default defineNuxtPlugin({
  name: 'msw',
  enforce: 'pre',
  async setup() {
    const { public: { apiMocking } } = useRuntimeConfig()
    if (!import.meta.dev || apiMocking !== 'enabled')
      return

    const { setupWorker } = await import('msw/browser')
    const { handlers } = await import('~/msw/handlers')
    const { resolveScenarioHandlers } = await import('~/msw/scenarios')

    // Dynamic mock scenario : la page (pathname) + `?scenario=...` lus dans
    // l'URL déterminent un jeu de handlers préfixé aux handlers de base
    // (le plus à gauche gagne). @see ~/msw/scenarios.ts
    const scenarioHandlers = resolveScenarioHandlers(
      window.location.pathname,
      new URLSearchParams(window.location.search).get('scenario'),
    )

    const worker = setupWorker(...scenarioHandlers, ...handlers)
    await worker.start({
      // Laisse passer toutes les requêtes sans handler (assets Nuxt, HMR…)
      onUnhandledRequest: 'bypass',
    })
  },
})
